import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    content: [],
    loading: true
  },
  mutations: {
    SAVE_DATA (state, data) {
      state.content = data;
      state.loading = false;
    }, 
  },
  actions: {
    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        if(state.content.length > 0) {
          resolve();
          return;
        }

        axios
          .get("https://data.kro-ncrv.nl/data/copy/2021-exposing.json")
          .then(result => {
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    
  },
  modules: {

  }
})
